import { logUsage } from 'owa-analytics';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isLinkPrefixedWithBaseUrl, isSharePointLink } from 'owa-sharepoint-link-detector';
import { parse as parseUrl } from 'url';
import {
    BOX_BASE_URL,
    DROP_BOX_BASE_URL,
    GDRIVE_BASE_URL,
    GDRIVE_DOCS_BASE_URL,
    ONE_DRIVE_CONUSMER_BASE_URL,
} from './constants';

export function isOneDriveConsumerLink(url: string): boolean {
    return isLinkPrefixedWithBaseUrl(url, ONE_DRIVE_CONUSMER_BASE_URL);
}

export function isDropboxLink(url: string): boolean {
    return isLinkPrefixedWithBaseUrl(url, DROP_BOX_BASE_URL);
}

export function isBoxLink(url: string): boolean {
    return isLinkPrefixedWithBaseUrl(url, BOX_BASE_URL);
}

export function isGDriveLink(url: string): boolean {
    return (
        isLinkPrefixedWithBaseUrl(url, GDRIVE_BASE_URL) ||
        isLinkPrefixedWithBaseUrl(url, GDRIVE_DOCS_BASE_URL)
    );
}

function logUnknownDomain(url: string, providerType: AttachmentDataProviderType) {
    const domain: string = parseUrl(url).hostname;
    logUsage(
        'FileProviderSharingLinkUnknownDomain',
        {},
        {
            cosmosOnlyData: JSON.stringify({
                unknownDomain: domain,
                fileProviderType: providerType,
            }),
        }
    );
}

export function checkSharingLinkUrlDomain(url: string, providerType: AttachmentDataProviderType) {
    let isValidLink: boolean = false;
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            isValidLink = isSharePointLink(url);
            break;
        case AttachmentDataProviderType.OneDriveConsumer:
            isValidLink = isOneDriveConsumerLink(url);
            break;
        case AttachmentDataProviderType.Dropbox:
            isValidLink = isDropboxLink(url);
            break;
        case AttachmentDataProviderType.Box:
            isValidLink = isBoxLink(url);
            break;
        case AttachmentDataProviderType.GDrive:
            isValidLink = isGDriveLink(url);
            break;
        default:
            throw new Error(`checkSharingLinkUrlDomain do not support ${providerType}`);
    }
    if (!isValidLink) {
        logUnknownDomain(url, providerType);
    }
}
